export default class PlanDocumentNested {
  document_id: string;
  service_area?: string;
  rating_region?: string;
  type: string;
}
